import React from 'react';
import ReactDOM from 'react-dom/client';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { BrowserRouter } from 'react-router-dom';
import { MsalProvider } from '@azure/msal-react';
import { msalInstance, initializeMsal } from './lib/msal-config';
import { MaintenanceGuard } from './components/MaintenanceGuard';
import App from './App';
import './index.css';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 1000 * 60 * 5,
      retry: (failureCount, error) => {
        // Don't retry on authentication errors
        if (error instanceof Error && (error.message.includes('401') || error.message.includes('Session expired'))) {
          return false;
        }
        return failureCount < 1;
      },
    },
  },
});

function renderApp() {
  ReactDOM.createRoot(document.getElementById('root')!).render(
    <React.StrictMode>
      <MsalProvider instance={msalInstance}>
        <QueryClientProvider client={queryClient}>
          <BrowserRouter>
            <MaintenanceGuard>
              <App />
            </MaintenanceGuard>
          </BrowserRouter>
        </QueryClientProvider>
      </MsalProvider>
    </React.StrictMode>
  );
}

async function startApp() {
  try {
    // Initialize MSAL before rendering (required for v5)
    // MsalProvider will handle handleRedirectPromise() internally
    await initializeMsal();
  } catch (error) {
    // Log but don't block - app can still render, user will just need to login
    console.error('MSAL initialization failed, continuing without auth:', error);
  }

  // Always render the app
  renderApp();
}

// Start the application
startApp();
